import Combobox from '@/components/common/Combobox';
import insertBreakOpportunities from '@/components/general/FieldNameConvert';
import { breakRegex, DROPOFF_SELECT_OPTION, INSURENCE_SELECT_OPTION } from '@/configs/constants';
import { OPTION_FORMAT, OptionFormatType } from '@/types/enums';
import { OptionOtherSetting } from '@/types/option';
import { formatCurrency } from '@/utils/formatNumber';
import { cn } from '@/utils/utils';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface OptionSelectItemProps {
    type: OptionFormatType,
    option: OptionOtherSetting,
    selectedValue: string,
    onChangeValueFn: Function,
    disabled?: boolean,
    optionNameClass?: string,
    inputClassName?: string,
    comboboxClass?: string,
    isCheckOffOption?: boolean,
    useSearch?: boolean
}

export default function OptionSelectItem({ type, option, onChangeValueFn, selectedValue, disabled = false, optionNameClass, inputClassName, comboboxClass, isCheckOffOption = false, useSearch = false }: OptionSelectItemProps) {
    // hook
    const { t } = useTranslation();

    const listDataSelectByType = () => {
        let data: any[] = [];
        switch (type) {
            case OPTION_FORMAT.Option:
            case OPTION_FORMAT.ExtraMileage:
                data = Array.from({ length: option.maxValue ? (option.maxValue + 1) : 2 }).map((_, number) => ({
                    label: (number).toString(),
                    value: (number).toString()
                }));
                break;
            case OPTION_FORMAT.Insurance:
                data = Object.keys(INSURENCE_SELECT_OPTION).map(key => ({
                    label: (INSURENCE_SELECT_OPTION[key].label).toString(),
                    value: (INSURENCE_SELECT_OPTION[key].value).toString()
                }));
                break;
            case OPTION_FORMAT.DropOff:
                data = Object.keys(DROPOFF_SELECT_OPTION).map(key => ({
                    label: (DROPOFF_SELECT_OPTION[key].label).toString(),
                    value: (DROPOFF_SELECT_OPTION[key].value).toString()
                }));
                break;
        }

        return data;
    };

    let checkExistBreakSymbol = breakRegex.test(option?.name?.toString() || '');

    return (
        <div className={classNames('w-full grid items-center border-x border-b border-[#E6E6E6]', type !== OPTION_FORMAT.DropOff ? 'grid-cols-3' : 'grid-cols-2')}>
            <div
                className={cn(
                    'input-common-item flex items-center break-on-wbr justify-end font-medium bg-[#F8F7F1] text-right border-r border-[#E6E6E6]',
                    optionNameClass
                )}
            >
                <p className={classNames(type === OPTION_FORMAT.DropOff && 'whitespace-pre-line')}>
                    {checkExistBreakSymbol ? insertBreakOpportunities({ text: option.name?.toString() || '', isSmallerSide: type === OPTION_FORMAT.Insurance }) : option.name}
                </p>
            </div>
            {
                type !== OPTION_FORMAT.DropOff && (
                    <div className='input-common-item flex items-center justify-center h-full border-r'>
                        {option.price && `${formatCurrency(option.price)}${t('currency.currency_unit')}${option?.mileageLimit ? option?.mileageLimit : ''}`}
                    </div>
                )
            }
            <div className={cn('input-common-item flex items-center justify-center h-full', inputClassName)}>
                <Combobox
                    search={useSearch && listDataSelectByType().length >= 10}
                    items={listDataSelectByType()}
                    value={selectedValue.toString()}
                    onChange={(item) => {
                        onChangeValueFn(item.value.toString());
                    }}
                    className={cn(
                        'xsm:w-24 bg-white border border-border-gray w-full rouned-[5px] h-[30px] xsm:text-sm text-[12px] xsm:pr-4 point-375:pr-2 pr-[2px] xsm:pl-2 pl-1',
                        isCheckOffOption && 'xsm:w-32',
                        comboboxClass
                    )}
                    commandListClassName='max-h-[200px]'
                    arrowDownClass='xsm:right-3 right-1'
                    disabled={disabled}
                    disableClearIcon
                />
            </div>
        </div>
    );
}
